export default _theme => {
  return {
    root: {
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '0 8px',
      maxWidth: '100%'
    },
    chip: {
      maxWidth: '100%',
      '& [class*="HoiPoi__Text__root"]': {
        display: 'block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      }
    }
  };
};